import {
  Box,
  Dialog,
  FormControlLabel,
  IconButton,
  Typography,
  styled,
} from '@mui/material';

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 30,
    backgroundColor: theme.palette.common.white,
    padding: '48px',
    minHeight: 'auto',
    [theme.breakpoints.down('xl')]: {
      minWidth: 690,
      '& .css-biqaug': {
        margin: '48px 60px',
      },
    },
    [theme.breakpoints.up('xl')]: {
      minWidth: 790,
    },
  },
  '& .MuiDialog-paperScrollPaper': {
    '&::-webkit-scrollbar': {
      width: 10,
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.secondary.main,
      borderRadius: 10,
      '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
      },
    },
    '&::-webkit-scrollbar-track': {
      margin: '60px 0',
    },
  },
}));

export const TopBox = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
}));

export const CloseButton = styled(IconButton)(({ theme }) => ({
  margin: '-28px -28px 0 0',
  height: 'fit-content',
  '& span': {
    fontSize: '24px',
    fontWeight: '600',
    color: theme.palette.secondary.main,
  },
}));

export const DialogTitle = styled(Typography)(({ theme }) => ({
  font: '700 21px Montserrat',
  textTransform: 'capitalize',
  color: '#595959',
  marginBottom: 24,
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  '& span': { color: theme.palette.secondary.main },
}));

export const AssingData = styled(Box)(({ theme }) => ({
  width: '100%',
  height: 46,
  border: `1px solid ${theme.palette.secondary.main}`,
  color: theme.palette.secondary.main,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: 2,
}));

export const CheckboxFormControl = styled(FormControlLabel)(({ theme }) => ({
  '& .MuiButtonBase-root': {
    color: theme.palette.common.grey,
  },
  '&:hover': {
    '& .MuiTypography-root': {
      fontWeight: '600',
    },
  },
}));
